<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>UNDER THE HOOD</div>
				<h2 waHeading="l" waText>What Just Happened?</h2>
				<p waBody="m" waColorText="quiet" waText>Same Java code &mdash; different runtime behaviour depending on your mode.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="m" waText>Under the hood, what happened depends on your mode:</p>
				<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Angular Mode &mdash; TypeScript Generated</h3>
							<p waBody="m" waColorText="quiet" waText>The Angular Maven Plugin scanned your &#64;NgApp and &#64;NgComponent classes and generated .ts files, angular.json, package.json, tsconfig.json, and routing modules.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Angular Mode &mdash; Angular Built</h3>
							<p waBody="m" waColorText="quiet" waText>npm install and ng build --configuration production ran automatically during mvn install. The output is a static SPA ready to deploy anywhere.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Hosted Mode &mdash; Vert.x Serving</h3>
							<p waBody="m" waColorText="quiet" waText>IGuiceContext.inject&#40;&#41; discovered JWebMPVertx via SPI, started a non-blocking HTTP server, and registered routes for pages, AJAX events, WebSockets, CSS, and scripts.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Both Modes &mdash; SPI Wired</h3>
							<p waBody="m" waColorText="quiet" waText>Every IPageConfigurator, IEventConfigurator, and render-ordering hook was discovered and applied &mdash; WebAwesome CSS/JS injected, theme classes added. Guice bindings resolved via ServiceLoader and module-info.java.</p>
						</div>
					</wa-card>
				</div>
			</div>
		</div>
	</div>
</div>